import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((/* theme */) => ({
  wrapper: { marginTop: 20 },
}));

export default useStyles;
